export default __webpack_public_path__ + "static/media/(73).b563dc07.jpg";